import React from 'react';
import Hero from '../components/Hero';

const Home = () => {
  return (
    <div className="home">
      <Hero />
    </div>
  );
};

export default Home;